<div class="dialog-header">
  <mat-icon class="dialog-back" (click)="$event.stopPropagation(); tryClose('back')">chevron_left</mat-icon>
  <span class="dialog-title">{{ isEdit ? 'Textblock bearbeiten' : 'Textblock hinzufügen' }}</span>
  <mat-icon class="dialog-close" (click)="$event.stopPropagation(); tryClose(null)">close</mat-icon>
</div>
<div class="dialog-body">
  <label class="field-label">Titel</label>
  <input class="field-input" [formControl]="$any(form.controls['title'])" maxlength="500">

  <label class="field-label">Beschreibungstext*</label>
  <textarea class="field-input" [class.field-error]="form.controls['body_text'].invalid && form.controls['body_text'].touched"
            [formControl]="$any(form.controls['body_text'])" rows="8" maxlength="500"></textarea>
  @if (form.controls['body_text'].invalid && form.controls['body_text'].touched) {
    <p class="validation-error">Beschreibungstext ist ein Pflichtfeld.</p>
  }
</div>
<div class="dialog-footer">
  <button class="dialog-save-btn" (click)="save()" [disabled]="form.invalid">Speichern</button>
</div>
